import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { environment } from '../../../../environments/environment';

type EnvironmentName = 'development' | 'staging' | 'production';

@Component({
  selector: 'app-environment-ribbon',
  standalone: true,
  imports: [NgClass],
  template: `
    @if (!isProduction) {
    <div
      class="fixed top-0 left-0 z-[99999] pointer-events-none"
      style="width: 120px; height: 120px; overflow: hidden"
    >
      <div
        [ngClass]="ribbonClasses"
        class="absolute text-white text-[10px] font-bold uppercase tracking-widest text-center leading-[28px] shadow-md pointer-events-auto select-none"
        style="
          width: 170px;
          top: 18px;
          left: -42px;
          transform: rotate(-45deg);
          transform-origin: center;
        "
        [title]="'Environment: ' + envName"
      >
        {{ envName }}
      </div>
    </div>
    }
  `,
})
export class EnvironmentRibbonComponent {
  readonly envName: EnvironmentName = environment.environmentName;
  readonly isProduction = environment.production;

  get ribbonClasses(): string {
    switch (this.envName) {
      case 'development':
        return 'bg-gradient-to-r from-amber-500 to-orange-500';
      case 'staging':
        return 'bg-gradient-to-r from-violet-500 to-purple-600';
      default:
        return '';
    }
  }
}


